<template>
  <div class="content-au">
    <SearchInput
      :value="query"
      :placeholder="'输入地区，医院，科室，疾病'"
      :is-from-aut="true"
      @update:value="query = $event"
      @keypress="queryHospitalList"
      @clear="onSearchClear"
    />
    <div v-if="isPageLoading" class="page-loading">
      <cube-loading />
    </div>
    <div id="doc-list" :class="{ 'doc-list': true, 'scroll-auto': isResult }">
      <div v-if="!isResult" id="content-top" class="content-top">
        <a href="/v3-m-expert-service/service-intro/?from_page=expert_index">
          <img
            class="banner-img"
            src="https://resource.chunyu.mobi/@/media/images/2024/05/07/4a70/f89fc8f7ac64_w1125_h516_.png"
            alt="权威专家"
          />
        </a>
        <div v-if="!!diseaseList.length" class="disease-content">
          <common-title
            title="按疾病"
            :sub-title="'重疑难杂症放心看'"
            :is-more="true"
            :more-text="'更多疾病'"
            @on-more-click="onMoreDisease"
          />
          <ul class="dis-lable">
            <li
              v-for="(item, index) in diseaseList"
              :key="index"
              @click="onDisLable(item.name)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div v-if="!!hospitalList.length" class="hospital-guide-au">
          <hospital-guide
            :title="'按医院'"
            :sub-title="'十强科室，百强医院'"
            :more-text="'更多医院'"
            :hospital-list="hospitalList"
            @on-hospital-click="onHospitalClick"
            @on-more-click="onMoreHospital"
          />
        </div>
      </div>
      <div id="filter" :class="{ filter: true, fixed: isResult }">
        <filter-select
          ref="filter"
          :filter-options="filterOptions"
          :value="filterValue"
          :mount-element="'doc-list'"
          :is-height-filter="isHeightFilter"
          @change="onFilterChange"
          @onMulChange="onMulChange"
          @optionItemChange="optionItemChange"
          @onClose="onFilterClose"
        />
      </div>
      <List
        ref="list"
        :is-no-data="!doctorList.length"
        :finished-text="!isMore && doctorList.length ? '暂无更多' : ''"
        :no-data-icon="
          'https://staff.chunyu.mobi/@/media/images/2021/12/22/4510/29fccc141f91_w120_h80_.png'
        "
        :no-data-message="'暂无数据'"
        :mount-element="'doc-list'"
        :loading="isLoading"
        @onLoad="loadMore"
      >
        <doctor-card
          v-for="(item, index) in doctorList"
          :key="index"
          :doctor-info="item.doctor_info"
          :index="index"
          @click="onDoctorCard"
        />
      </List>
    </div>
  </div>
</template>
<script>
import cyShare from '@cy/share';
// eslint-disable-next-line import/no-extraneous-dependencies
import SearchInput from '@@/components-business-m/src/search-input';
// eslint-disable-next-line import/no-extraneous-dependencies
import { visitRecordReport } from '@@/utils/pageVisitRecord.js';
import * as cyDetect from '@cy/detect';
import FilterSelect from '@/components/FilterSelect';
import {
  getLocation,
  searchClinicList,
  doctorList,
  doctorConf,
  searchDisease,
} from '@/services/index';
import List from '@/components/List';
import { doPoint } from '@/utils/index';
import HospitalGuide from './components/HospitalGuide.vue';
import DoctorCard from './components/DoctorCard';
import CommonTitle from './components/CommonTitle.vue';

const wx = require('weixin-js-sdk');

const NORMAL_SEARCH_STORAGE_KEY = 'NOEMAL_SEARCH_OPTIONS';
// 当前运行环境（打点参数，感觉除了用户端内都记为小程序是有点问题的）
const APP_ENV = cyDetect.isFromCY() ? '0' : 'weixin_mini';

export default {
  name: 'AuthoritativeExpert',
  components: {
    SearchInput,
    DoctorCard,
    FilterSelect,
    HospitalGuide,
    List,
    CommonTitle,
  },
  data: () => {
    return {
      isResult: false, // 是否是结果页
      doctorList: [], // 权威专家列表
      diseaseList: [], // 按疾病
      query: '', // 搜索的关键词
      province: '', // 省份
      city: '', // 城市
      clinicNo: '', // 一级科室
      secondClassClinicNo: '', // 二级科室
      filterList: [], // 筛选项
      page: 1, // 页数
      sortType: '', // 排序
      isMore: true, // 是否有更多
      queryInfo: {}, // 查询信息
      shareInfo: {}, // 分享信息
      fromWxMini: '', // 是否是微信环境
      isApp: false, // 是否在端上
      isLoading: false, // 是否等待加载
      filterOptions: [
        { name: '全国', isFocus: false, filterType: 'select', data: [] },
        { name: '科室', isFocus: false, filterType: 'select', data: [] },
        // TODO 疾病后续需要更改
        { name: '疾病', isFocus: false, filterType: 'multistage', data: [] },
        {
          name: '医院排名从高到低',
          isFocus: false,
          filterType: 'sort',
          data: [],
        },
        { name: '筛选', isFocus: false, filterType: 'filter', data: [] },
      ], // 筛选配置项
      hospitalList: [], // 医院指南医院列表
      // 筛选器的值
      filterValue: [
        ['', ''],
        ['', ''],
        ['', ''],
        ['price_desc', ''],
        ['', ''],
      ],
      isTouchTop: false, // 筛选器是否置顶
      isPageLoading: true, // 页面加载
      inputType: '', // 打点用
      isHeightFilter: false, // 是否高亮筛选
      doPointStr: '', // 列表页权威专家打点
      // 10.1.8新增参数，需传给医生主页
      synonymQuery: '', // 搜索同义词
      intention: '', // 搜索意向
      serverParams: '',
    };
  },
  computed: {
    // 数据上报等定义的页面名称
    pageReadableName() {
      if (this.isResult) {
        return '权威专家列表页';
      }
      return '权威专家首页';
    },
    // 来源类型
    fromType() {
      if (this.isResult) {
        return this.$route.query.do_point_str || '集合卡片查看更多';
      }
      return this.$route.query.from_type === '1' ? '找医生' : '金刚位';
    },
    // 来源页面名称
    fromVisitPage() {
      if (this.$route.query.from_visit_page) {
        return this.$route.query.from_visit_page;
      }
      return this.fromType;
    },
  },
  mounted() {
    if (this.$route.query.is_result) return;
    // 监听页面滑动，为筛选器设置定位
    window.addEventListener('scroll', this.onPageScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onPageScroll);
  },
  created() {
    doPoint('PageView', {
      app: APP_ENV,
      page_readable_name: this.pageReadableName,
      from_type: this.fromType,
    });
    this.init();
  },
  methods: {
    /**
     * 初始化
     */
    async init() {
      this.isPageLoading = true;

      // 获取页面筛选项信息
      Promise.all([
        this.getClinicOptions(),
        this.getDiseaseOptions(),
        this.getLocationOptions(),
        this.getOtherOptions(),
      ])
        .then(() => {
          this.isPageLoading = false;
        })
        .catch(() => {
          this.isPageLoading = false;
        });

      this.getParamsFromUrl();
      this.searchDoctorList();
      this.pageVisitReport();
    },
    /**
     * 从 url 中解析筛选参数（区域、科室、疾病等）
     */
    getParamsFromUrl() {
      const {
        query,
        clinic_no,
        second_class_clinic_no,
        is_result,
        sort_type,
        province,
        city,
        filter1 = '',
        filter2 = '',
        input_type,
        server_params,
      } = this.$route.query;

      this.query = query || '';
      this.inputType = input_type || '';
      this.sortType = sort_type;
      this.isResult = is_result;
      this.filterList = [[...filter1.split(',')], [...filter2.split(',')]];

      let serverParamsObj = {};
      if (server_params) {
        try {
          serverParamsObj = JSON.stringify(server_params);
        } catch (error) {
          console.log('JSON.stringify error::', error);
        }
      }
      this.clinicNo = serverParamsObj.clinic_no || clinic_no;
      this.secondClassClinicNo =
        serverParamsObj.second_class_clinic_no || second_class_clinic_no;
      this.province = serverParamsObj.province || province;
      this.city = serverParamsObj.city || city;
      this.filterValue = [
        [this.province || '', this.city || ''],
        [this.clinicNo || '', this.secondClassClinicNo || ''],
        ['', ''],
        [sort_type || '', ''],
        [filter1 || '', filter2 || ''],
      ];
    },
    /**
     * 筛选器关闭的回调
     */
    onFilterClose() {
      this.filterValue = [
        [this.province || '', this.city || ''],
        [this.clinicNo || '', this.secondClassClinicNo || ''],
        ['', ''],
        [this.sortType || '', ''],
        [
          Array.isArray(this.filterList[0])
            ? this.filterList[0].join(',')
            : this.filterList[0],
          Array.isArray(this.filterList[1])
            ? this.filterList[1].join(',')
            : this.filterList[1],
        ],
      ];
    },
    /**
     * 筛选器发生改变的回调函数
     *
     * @param {Array} value 筛选器的值
     * @param {string} filterCat 筛选类别
     */
    onFilterChange(value, filterCat) {
      this.inputType = filterCat;
      this.filterValue = value;
      const [
        [province, city],
        [clinic_no, second_class_clinic_no],
        [a],
        [sort_type],
        filterList,
      ] = value;
      console.log(a);
      this.filterList = [filterList['0'] || [], filterList['1'] || []];
      this.clinicNo = clinic_no;
      this.secondClassClinicNo = second_class_clinic_no;
      this.province = province;
      this.city = city;
      this.sortType = sort_type;
      this.goResult(true);
    },
    /**
     * 点击更多疾病
     */
    onMoreDisease() {
      const clickPosition = '更多疾病';
      this.pageVisitReport(clickPosition, 0).then(() => {
        doPoint('AppClick', {
          app: APP_ENV,
          click_position: clickPosition,
          page_readable_name: this.pageReadableName,
        }).finally(() => {
          window.location.href = `/v-m-general/authoritative-expert?is_result=1&option_item=疾病&do_point_str=更多疾病&from_visit_page=${this.pageReadableName}`;
        });
      });
    },
    /**
     * 点击按疾病标签
     *
     * @param {string} name 被点击的疾病
     */
    onDisLable(name) {
      const clickPosition = '常见疾病';
      doPoint('AppClick', {
        app: APP_ENV,
        page_readable_name: this.pageReadableName,
        click_position: clickPosition,
        click_position_value: name,
      }).finally(() => {
        this.inputType = '疾病筛选';
        this.doPointStr = clickPosition;
        this.query = name;
        this.pageVisitReport({
          clickPosition,
          clickOrder: 0,
        }).then(() => {
          this.goResult(false);
        });
      });
    },
    /**
     * 获取权威专家列表
     *
     * @param {boolean} isReset 是否重新请求
     */
    searchDoctorList(isReset) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      if (isReset) {
        if (this.isResult) {
          this.$refs.list.initStatus(0);
        } else {
          const contentTop = document.getElementById('content-top');
          const branTop = contentTop ? contentTop.offsetHeight : 480;
          this.$refs.list.initStatus(branTop);
        }
      }

      this.setShareInfo();
      const params = this.getSearchParams(isReset);

      doctorList(params)
        .then(res => {
          this.isLoading = false;
          const { data, error_code, error_msg } = res;
          if (error_code === 0) {
            this.isMore = data.has_more;
            this.serverParams = data.server_params || '';
            this.doctorList = isReset
              ? data.item_list
              : [...this.doctorList, ...data.item_list];
            this.synonymQuery = data.synonym_query || '';
            this.intention = data.intention || '';
          } else {
            this.$createToast({
              time: 1000,
              txt: error_msg || '获取医生列表失败',
              type: 'txt',
            }).show();
          }
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
    },
    /**
     * 获取权威专家查询参数
     *
     * @param {boolean} isReset 是否重新请求
     */
    getSearchParams(isReset) {
      if (isReset) {
        this.page = 1;
      }

      const arr = []; // 其他筛选项选中值对应的 filter_dict 组成的数组
      const filterl = []; // 其他筛选项值(是否可直接咨询、医生职称等)

      if (this.filterList.length) {
        this.filterList.forEach(item => {
          if (!Array.isArray(item)) {
            filterl.push(...item.split(','));
          } else {
            filterl.push(...item);
          }
        });
        const normalSearchList =
          JSON.parse(localStorage.getItem(NORMAL_SEARCH_STORAGE_KEY)) || [];
        filterl.forEach(item => {
          normalSearchList.forEach(ele => {
            const temp = ele.item_list.find(e => e.name === item);
            if (temp) {
              arr.push(temp.filter_dict);
            }
          });
        });
      }
      this.isHeightFilter = !!arr.filter(item => !!item).length;

      const result = {
        from_type: '3',
        sort_type: this.sortType || 'hospital_rank',
        page: this.page,
        query: this.query,
        province: this.province,
        city: this.city,
        clinic_no: this.secondClassClinicNo || this.clinicNo,
        filter_list: JSON.stringify(arr.filter(item => !!item)),
        input_type: this.inputType,
        source_type: '权威专家',
        secureId: this.$route.query.cyudId || this.$route.query.secureId,
      };
      return result;
    },
    /**
     * 获取疾病筛选项
     */
    async getDiseaseOptions() {
      try {
        const { error_code, error_msg, data = [] } = await searchDisease({
          from_type: 3,
        });
        if (error_code === 0) {
          this.filterOptions[2].data = data || [];
          if (this.$route.query.option_item === '疾病') {
            this.$refs.filter.onOption(this.filterOptions[2]);
          }
        } else {
          console.log('getDiseaseOptions fail::', error_msg);
        }
      } catch (err) {
        console.log('getDiseaseOptions error::', err);
      }
    },
    /**
     * 获取地区筛选项
     */
    async getLocationOptions() {
      try {
        const { error_code, error_msg, data = [] } = await getLocation();
        if (error_code === 0) {
          const locationOptions = [
            { text: '全国', value: '', childer: [{ text: '全国', value: '' }] },
          ];
          data.forEach(first => {
            const secondList = (first.sub_data || []).map(second => {
              return {
                text: second.text,
                value: second.text,
              };
            });
            secondList.unshift({ text: first.text, value: '' });
            locationOptions.push({
              text: first.text,
              value: first.text,
              childer: secondList,
            });
          });
          this.filterOptions[0].data = locationOptions;
          // todo 判断必要性
          this.getParamsFromUrl();
        } else {
          console.log('getLocationOptions fail::', error_msg);
        }
      } catch (err) {
        console.log('getLocationOptions error::', err);
      }
    },
    /**
     * 获取科室筛选项
     */
    async getClinicOptions() {
      try {
        const { error_code, error_msg, data = [] } = await searchClinicList();
        if (error_code === 0) {
          const clinicOptions = [];
          data.forEach(item => {
            const secondList = (item.second_class_clinics || []).map(second => {
              return {
                text: second.clinic_name,
                value: second.clinic_no,
              };
            });
            clinicOptions.push({
              text: item.clinic_name,
              value: item.clinic_no,
              childer: secondList,
            });
          });
          this.filterOptions[1].data = clinicOptions;
          // todo 判断必要性
          this.getParamsFromUrl();
        } else {
          console.log('getClinicOptions fail::', error_msg);
        }
      } catch (err) {
        console.log('getClinicOptions error::', err);
      }
    },
    /**
     * 获取页面其他筛选项
     */
    async getOtherOptions() {
      try {
        const { error_code, error_msg, data = [] } = await doctorConf({
          from_type: 3,
          conf_type_list: JSON.stringify([1, 2, 3, 6, 7]),
        });
        if (error_code === 0) {
          // 按医院 -- 医院列表
          this.hospitalList = data.hospital_list || [];

          // 医院排名（todo sort_type 为什么要赋空值）
          this.filterOptions[3].data = (data.sort_list || []).map(item => {
            return {
              name: item.name,
              value: item.sort_type === 'hospital_rank' ? '' : item.sort_type,
            };
          });

          // 按疾病 -- 疾病列表
          this.diseaseList = data.disease_list || [];

          // 筛选 -- 其他
          localStorage.setItem(
            NORMAL_SEARCH_STORAGE_KEY,
            JSON.stringify(data.normal_search_list)
          );
          this.filterOptions[4].data = (data.normal_search_list || []).map(
            (item, index) => {
              const options = item.item_list.map(e => {
                return {
                  name: e.name,
                  value: e.name,
                };
              });
              return {
                title: item.group_name,
                key: `${index}`,
                options,
              };
            }
          );
          // todo 判断必要性
          this.getParamsFromUrl();
        } else {
          this.$createToast({
            time: 1000,
            txt: error_msg || '获取页面配置失败',
            type: 'txt',
          }).show();
        }
      } catch (err) {
        console.log('getOtherOptions error::', err);
      }
    },
    /**
     * 顶部搜索框，监听键盘事件
     *
     * @param {boolean} isDelete 是否是删除
     */
    queryHospitalList(isDelete) {
      this.inputType = 'query';
      this.doPointStr = '搜索query';
      this.goResult(isDelete || this.isResult);
    },
    /**
     * 加载更多
     */
    loadMore() {
      if (this.isMore && !this.isLoading) {
        this.page += 1;
        this.searchDoctorList();
      }
    },
    /**
     * 筛选器多级选择
     *
     * @param {string} disName 被选择的值
     */
    onMulChange(disName) {
      this.inputType = '疾病筛选';
      this.doPointStr = '疾病筛选项';
      this.query = disName;
      if (!this.isResult) {
        this.pageVisitReport({
          clickPosition: '疾病筛选项',
          clickOrder: 0,
        }).then(() => {
          this.goResult(this.isResult);
        });
      } else {
        this.goResult(this.isResult);
      }
    },
    /**
     * 跳转到结果页
     *
     * @param {boolean} isCurrent 是否在当前页
     */
    goResult(isCurrent) {
      // 当前页面是权威专家列表或在当前页进行筛选
      if (this.isResult || isCurrent) {
        this.searchDoctorList(true);
        return;
      }

      // 当前页是权威专家首页
      if (!this.isResult) {
        if (this.isCurrent) {
          this.searchDoctorList(true);
        } else {
          const { query } = this;
          this.query = '';
          window.location.href = this.getJumpHref(query);
        }
      }
    },
    /**
     * 点击医生卡片回调事件
     *
     * @param {object} doctorInfo 被点击的医生信息
     * @param {number} index 被点击的医生的排名
     */
    onDoctorCard(doctorInfo, index) {
      const clickPosition = '医生卡片';
      doPoint('AppClick', {
        app: APP_ENV,
        page_readable_name: this.pageReadableName,
        click_position: '医生卡片',
        doctor_id: doctorInfo.doctor_id,
        doctor_name: doctorInfo.name,
        list_order: index + 1,
      }).finally(() => {
        this.pageVisitReport({
          cyRedirect: doctorInfo.cy_redirect?.click_info,
          clickPosition,
          clickOrder: index + 1,
        }).then(() => {
          this.goDoctorHome(doctorInfo);
        });
      });
    },
    /**
     * 跳转医生主页
     *
     * @param {object} doctorInfo 医生信息
     */
    goDoctorHome(doctorInfo) {
      const { has_online_services, doctor_id, name, clinic_name } = doctorInfo;

      // 未开通线上服务时，跳转预约页面
      const offlineService = `/vip_doctor/template/?view_key=doctor_main&doc_id=${doctor_id}&source=vip&query=${this.query}&intention=${this.intention}&synonym_query=${this.synonymQuery}&server_params=${this.serverParams}`;
      // 客户端协议医生主页
      const nativeHome = `chunyu://launch/webapp/doctor/home?doctor_id=${doctor_id}&query=${this.query}&intention=${this.intention}&synonym_query=${this.synonymQuery}&server_params=${this.serverParams}`;
      // h5 医生主页
      const h5Home = `/cooperation/wap/doctor_detail_info/?doctor_id=${doctor_id}&source_type=vip&query=${name}&clinic_name=${clinic_name}&from_type=${this.pageReadableName}&partner=chunyu_wap&server_params=${this.serverParams}&intention=${this.intention}&synonym_query=${this.synonymQuery}`;
      // 小程序医生主页
      const wxMiniHome = `/pages/doc_mainpage/index?doc_id=${doctor_id}&source=vip&has_online_services=${has_online_services}&query=${this.query}&intention=${this.intention}&synonym_query=${this.synonymQuery}&server_params=${this.serverParams}`;

      if (cyDetect.isFromCY()) {
        // 用户端内
        window.location.href = has_online_services
          ? nativeHome
          : `${offlineService}#OPEN_NEW_WIN`;
      } else if (cyDetect.isFromWechat()) {
        // 微信环境内
        wx.miniProgram.getEnv(wxres => {
          if (wxres.miniprogram) {
            // 微信小程序内
            wx.miniProgram.navigateTo({
              url: has_online_services
                ? wxMiniHome
                : `/pages/h5_webview/index?url=${encodeURIComponent(
                    offlineService
                  )}`,
            });
          } else {
            // 普通微信浏览器内
            window.location.href = has_online_services
              ? h5Home
              : offlineService;
          }
        });
      } else {
        // 普通 h5 环境中
        window.location.href = has_online_services ? h5Home : offlineService;
      }
    },
    /**
     * 按医院 -- 查看更多
     */
    onMoreHospital() {
      const clickPosition = '更多医院';
      this.pageVisitReport({
        clickPosition,
        clickOrder: 0,
      }).then(() => {
        doPoint('AppClick', {
          app: APP_ENV,
          click_position: clickPosition,
          page_readable_name: this.pageReadableName,
        }).finally(() => {
          window.location.href = `/v-m-general/hospital-list?from_type=3&from_visit_page=${this.pageReadableName}`;
        });
      });
    },
    /**
     * banner图的医院卡片点击回调事件
     *
     * @param {string} name 医院名称
     */
    onHospitalClick(name) {
      const clickPosition = '医院卡片';
      doPoint('AppClick', {
        app: APP_ENV,
        page_readable_name: this.pageReadableName,
        click_position: clickPosition,
        click_position_value: name,
      }).finally(() => {
        this.query = name;
        this.doPointStr = clickPosition;
        this.inputType = '医院筛选';
        this.pageVisitReport({
          clickPosition,
          clickOrder: 0,
        }).then(() => {
          this.goResult(false);
        });
      });
    },
    /**
     * 筛选器下拉框的显示隐藏回调事件
     */
    optionItemChange() {
      const filter = document.getElementById('filter');
      if (!filter.getAttribute('class').includes('fixed')) {
        const contentTop = document.getElementById('content-top');
        const branTop = contentTop ? contentTop.offsetHeight : 480;
        this.$refs.list.initStatus(branTop);
      }
    },
    /**
     * 清空搜索框的回调事件
     */
    onSearchClear() {
      this.query = '';
      if (this.isResult) {
        this.searchDoctorList(true);
      }
    },
    /**
     * 设置分享信息
     */
    setShareInfo() {
      const url = this.getJumpHref(this.query);
      const shareInfo = {
        title: '权威专家 精选百强名医，1v1深度咨询',
        userName: 'gh_681d3fd5683f',
        mini_id: 'gh_681d3fd5683f',
        link: url,
        path: `/pages/h5_webview/index?url=${encodeURIComponent(url)}`,
        mini_image:
          'https://staff.chunyu.mobi/@/media/images/2022/11/29/a7b3/5a208626852f_w800_h640_.png',
        wx_scene_timeline_desc: '权威专家 精选百强名医，1v1深度咨询',
      };
      cyShare.app(shareInfo);
    },
    /**
     * 设置跳转路由
     *
     * @param {string} query 搜索关键词
     */
    getJumpHref(query) {
      const searchParams = [
        `is_result=1`,
        `query=${query || ''}`,
        `province=${this.province || ''}`,
        `city=${this.city || ''}`,
        `clinic_no=${this.clinicNo || ''}`,
        `second_class_clinic_no=${this.secondClassClinicNo || ''}`,
        `sort_type=${this.sortType || ''}`,
        `filter1=${this.filterList[0] || ''}`,
        `filter2=${this.filterList[1] || ''}`,
        `input_type=${this.inputType}`,
        `do_point_str=${this.doPointStr}`,
        `from_visit_page=${this.pageReadableName}`,
      ];
      const paramsStr = searchParams.join('&');
      return `${window.location.origin}/v-m-general/authoritative-expert?${paramsStr}#OPEN_NEW_WIN`;
    },
    /**
     * 页面滑动事件
     *
     * @param {object} event addEventListener事件
     */
    onPageScroll(event) {
      if (!event) {
        return;
      }
      if (event.target.id !== 'doc-list') {
        return;
      }
      const { scrollTop } = event.target;
      const contentTop = document.getElementById('content-top');
      const branTop = contentTop ? contentTop.offsetHeight : 480;
      const filter = document.getElementById('filter');
      const docList = document.getElementById('doc-list');
      if (scrollTop >= branTop) {
        filter.classList.add('fixed');
        docList.classList.add('scroll-auto');
      } else {
        filter.classList.remove('fixed');
        docList.classList.remove('scroll-auto');
      }
    },
    /**
     * 基于 visitRecordReport 封装的，适合本页面的页面上报方法
     *
     * @param {object} visitInfo 上报信息
     */
    pageVisitReport(visitInfo) {
      const { cyRedirect, clickPosition, clickOrder } = visitInfo || {};
      let myCyRedirect = cyRedirect;
      if (cyRedirect && typeof cyRedirect === 'string') {
        try {
          myCyRedirect = JSON.parse(cyRedirect);
        } catch (err) {
          console.log('json.parse error>>>', cyRedirect);
        }
      }
      return visitRecordReport({
        fromName: this.fromVisitPage || '',
        name: this.pageReadableName || '',
        extraInfo: {
          filter: this.getSearchParams() || {},
          cy_redirect: myCyRedirect,
          click_position: clickPosition || '',
          click_order: clickOrder || 0,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
@mixin btn-border($border, $color, $radius) {
  position: relative;
  padding: rem(5) rem(8);
  color: $color;
  font-size: rem(13);
  line-height: rem(15);
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border: rem(1) solid $border;
    border-radius: rem($radius);
    transform: scale(0.5);
    transform-origin: 0 0;
    content: '';
  }
}
.content-au {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: rem(54);
  overflow: auto;
  overflow-x: hidden;
  .content-top {
    width: 100%;
    // padding-bottom: rem(10);
    overflow-x: hidden;
    img {
      width: 100%;
      margin-bottom: rem(10);
    }
  }
}
.disease-content {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // height: rem(151);
  margin: rem(-3) rem(10) rem(10) rem(10);
  // padding: rem(10) 0;
  background: #fff;
  border-radius: rem(4);
  .dis-lable {
    display: flex;
    flex-wrap: wrap;
    max-height: rem(66);
    padding: 0 rem(10) rem(10) rem(10);
    overflow: hidden;
    text-align: left;
    li {
      // display: inline-block;
      display: flex;
      align-items: center;
      height: rem(29);
      margin-right: rem(7);
      margin-bottom: rem(5);
      padding: 0 rem(10);
      color: #39d167;
      font-size: rem(13);
      @include btn-border(#39d167, #39d167, 2);
    }
  }
}
.hospital-guide-au {
  padding: 0 rem(10);
  padding-bottom: rem(10);
  ::v-deep .common-title {
    padding-bottom: 0;
  }
}
.filter {
  z-index: 1;
  width: 100%;
  height: rem(40);
  margin-bottom: rem(10);
  background: #fff;
}
.fixed {
  position: fixed;
  top: rem(54);
}
.doc-list {
  // position: absolute;
  width: 100%;
  height: 100%;
  padding-bottom: rem(20);
  overflow: auto;
  background: #f7f7f7;
}
.scroll-auto.doc-list {
  padding-top: rem(50);
}
.page-loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: rgba(0, 0, 0, 0.6);
}
</style>
